import { gql } from '@parkchirp/api-client';

export const GET_PARKER_STATUS_HISTORY = gql`
  query getParkerStatusHistory(
    $parkerId: String!,
    $tenantSubscriptionId: String
  ) {
      getParkerStatusHistory(
        parkerId: $parkerId,
        tenantSubscriptionId: $tenantSubscriptionId
      ) {
          id
          createdAt
          updatedAt
          action
          startDate
          endDate
          notes
          skipProration
      }
  }
`;

export const GET_PARKER_FOR_PARKER_DETAIL = gql`
    query getParker(
        $parkerId: String!,
        $tenantSubscriptionId: String
    ) {
        getParker(
            parkerId: $parkerId,
            tenantSubscriptionId: $tenantSubscriptionId
        ) {
            subscriptionId
            firstName
            lastName
            address
            city
            state
            zip
            phone
            countryCode
            email
            group
            reservedSpace
            rateId
            isSoldOut
            suspensionStatus
            terminationStatus
            accessSystemStatus
            accessDevices
            accessSystemMeta
            parkerAccessDevices {
              id
              dateActive
              dateAdded
              dateInactive
              deviceId
              status
              inactiveReason
              accessDeviceType {
                type
              }
            }
            pool
            passback
            sublotId
            sequenceNumber
            sequenceNumberLocked
            activatedDate
            availableTenantRateSublots {
              sublot {
                id
                name
              }
            }
			      parkerTypeName
        }
    }
`;

export const LIST_PARKERS_DEVICES = gql`
  query listParkerAccessDevices(
    $limit: Int
    $offset: Int
    $filters: [Filter]
    $order: Order
    $special: Special
    $tenantSubscriptionId: String
  ) {
    listParkerAccessDevices(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      special: $special
      tenantSubscriptionId: $tenantSubscriptionId
    ) {
      total
      limit
      offset
      parkerAccessDevices {
        type
        parkerId
        deviceIdentifier
        deviceStatus
        deviceDateActive
        deviceDateAdded
        deviceInactiveReason
        inAccessSystem
        deviceDateInactive
        parker {
          id
          first_name
          last_name
          suspension_status
          termination_status
          subscription {
            id
            subscription_name
            account_id
            billing_profile {
              id
              name
              facility_id
              facility {
                facility_number
                facility_name
              }
            }
          }
        }
      }
    }
  }
`;

export const LIST_PARKERS_ACCESS_DEVICES = gql`
  query listParkerAccessDevicesV2(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
    $tenantSubscriptionId: String
  ) {
    listParkerAccessDevicesV2(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      tenantSubscriptionId: $tenantSubscriptionId
    ) {
      total
      parkerAccessDevices {
        parkerId
        deviceId
        status
        dateActive
        dateAdded
        dateInactive
        accessDeviceType {
          type
        }
        parker {
          firstName
          lastName
          suspensionStatus
          terminationStatus
          subscription {
            id
            subscriptionName
            accountId
            billingProfile {
              facilityId
              facility {
                facilityNumber
                facilityName
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PARKER_ACCESS_DEVICES_CSV = gql`
    query getParkerAccessDevicesCsv(
        $filters: [Filter],
        $order: SortOrder,
        $tenantSubscriptionId: String,
      ) {
        getParkerAccessDevicesCsv(
            filters: $filters,
            order: $order,
            tenantSubscriptionId: $tenantSubscriptionId,
        ) {
            url
        }
    }
`;

export const LIST_VEHICLES = gql`
  query listVehicles(
    $limit: Int
    $offset: Int
    $filters: [Filter]
    $order: Order
    $special: Special
    $tenantSubscriptionId: String
  ) {
    listVehicles(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      special: $special
      tenantSubscriptionId: $tenantSubscriptionId
    ) {
      total
      limit
      offset
      vehicles {
        id
        parker_id
        make
        model
        license
        state
        color
        decal
        parker {
          id
          suspension_status
          termination_status
          first_name
          last_name
          reserved_space
          subscription {
            id
            subscription_name
            account_id
            billing_profile {
              facility_id
              facility {
                facility_name
                facility_number
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PREVIEW_INVOICES = gql`
  query getPreviewInvoices(
    $parkerIds: [String]!
  ) {
    getPreviewInvoices(
        parkerIds: $parkerIds
    ) {
      url
    }
  }
`;

export const GET_AUTO_INVOICE_PREVIEWS = gql`
  query getAutoInvoicePreviews(
    $facilityId: String!
    $parkingStartYear: String!
    $parkingStartMonth: String!
    $parkingEndYear: String
    $parkingEndMonth: String
    $accountId: String
    $subscriptionName: String
  ) {
    getAutoInvoicePreviews(
        facilityId: $facilityId
        parkingStartYear: $parkingStartYear
        parkingStartMonth: $parkingStartMonth
        parkingEndYear: $parkingEndYear
        parkingEndMonth: $parkingEndMonth
        accountId: $accountId
        subscriptionName: $subscriptionName
    ) {
      url
    }
  }
`;

export const LIST_PARKER_ACCESS_SYSTEM_HISTORY = gql`
  query listParkerAccessSystemHistory(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
    $tenantSubscriptionId: String
  ) {
    listParkerAccessSystemHistory(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      tenantSubscriptionId: $tenantSubscriptionId
    ) {
      total
      parkerAccessSystemHistory {
        id
        createdAt
        createdBy
        status
        action
        parker {
          id
          firstName
          lastName
          subscription {
            id
            subscriptionName
            accountId
            billingProfile {
              facility {
                id
                facilityName
                facilityNumber
                timezone
                integration
              }
            }
          }
        }
        createdByUser {
          email
          firstName
          lastName
          internalUseOnly
        }
      }
    }
  }
`;

export const SYNC_PARKER_IN_ACCESS_SYSTEM = gql`
  query listParkerAccessSystemHistory(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
    $tenantSubscriptionId: String
  ) {
    listParkerAccessSystemHistory(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      tenantSubscriptionId: $tenantSubscriptionId
    ) {
      total
      parkerAccessSystemHistory {
        id
        createdAt
        createdBy
        status
        action
        parker {
          id
          firstName
          lastName
          subscription {
            id
            subscriptionName
            accountId
            billingProfile {
              facility {
                id
                facilityName
                facilityNumber
                timezone
                integration
              }
            }
          }
        }
        createdByUser {
          email
          firstName
          lastName
        }
      }
    }
  }
`;

export const LIST_ALL_PARKERS_FROM_CACHE = gql`
query listAllParkersFromCache(
  $filters: [Filter]
  $facilityId: String
  $tenantSubscriptionId: String
) {
  listAllParkersFromCache(
    filters: $filters
    facilityId: $facilityId
    tenantSubscriptionId: $tenantSubscriptionId
  ) {
    count
    parkers {
      id
      subscriptionId
      parkerStartDate
    }
  }
}
`;

export const LIST_PARKERS_FROM_CACHE = gql`
  query listParkersFromCache(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
    $facilityId: String
    $tenantSubscriptionId: String
  ) {
    listParkersFromCache(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      facilityId: $facilityId
      tenantSubscriptionId: $tenantSubscriptionId
    ) {
      count
      parkers {
        id
        lastName
        firstName
        suspensionStatus
        facilityId
        facilityName
        facilityNumber
        sublot
        terminationStatus
        subscriptionName
        subscriptionId
        payorReadableId
        payorType
        rateName
        discountType
        discountAmount
        passType
        location
        group
        accessHours
        reservedSpace
        email
        phone
        address
        city
        state
        zip
        parkerStartDate
        parkerTerminationDate
        accountId
        readableId
        gross
        net
        rateId
        isUpdating
        sequenceNumber
        sequenceNumberLocked
        residentNonResident
        residentUnit
        tenantNonTenant
        tenantName
        parkerTypeName
      }
    }
  }
`;

export const GET_PARKERS_CSV = gql`
    query getParkersCSV(
        $limit: Int!
        $offset: Int!
        $filters: [Filter]
        $order: SortOrder
        $facilityId: String
        $subscriptionId: String
      ) {
        getParkersCSV(
            limit: $limit
            offset: $offset
            filters: $filters
            order: $order
            facilityId: $facilityId
            subscriptionId: $subscriptionId
        ) {
            url
        }
    }   
`;

export const GET_PARKERS_LPR_READINESS_CSV = gql`
    query getParkersLprReadinessCsv(
        $filters: [Filter]
        $facilityId: String
        $subscriptionId: String
      ) {
        getParkersLprReadinessCsv(
            filters: $filters
            facilityId: $facilityId
            subscriptionId: $subscriptionId
        ) {
            url
        }
    }
`;

export const GET_WAITLIST_PARKERS_CSV = gql`
    query getWaitlistParkersCSV(
        $filters: [Filter]
        $order: SortOrder
        $subscriptionId: String
      ) {
        getWaitlistParkersCSV(
            filters: $filters
            order: $order
            subscriptionId: $subscriptionId
        ) {
            url
        }
    }
`;
export const VALIDATE_PARKERS_ACCESS_DEVICE_ADDITION = gql`
  query validateParkerAccessDeviceAddition (
      $facilityIds: [String]!
      $parkerAccessDevicesFromFE: [ParkerAccessDeviceInputType]!
    ) {
      validateParkerAccessDeviceAddition (
        facilityIds: $facilityIds
        parkerAccessDevicesFromFE: $parkerAccessDevicesFromFE
      ) {
          errorMessages
        }
    }
`;

export const LIST_PARKERS_WITH_MONTHLY_FEE_ID = gql`
    query listParkersWithMonthlyFeeId(
        $filters: [Filter]
        $order: SortOrder
      ) {
        listParkersWithMonthlyFeeId(
            filters: $filters
            order: $order
        ) {
            url
        }
    }
`;

export const GET_PASH_DETAILS = gql`
    query getPashDetails(
        $id: Int!,
    ) {
        getPashDetails(
            id: $id,
        ) {
            response
        }
    }
`;

export const GET_PARKER_SKIP_PRORATION_VALUES = gql`
    query getParkerSkipProrationValues(
        $parkerIds: [String!]!
    ) {
      getParkerSkipProrationValues(
        parkerIds: $parkerIds,
      ) {
        parkerId
        skipProration
      }
    }
`;

export const LIST_WAITLISTED_PARKERS = gql`
    query listWaitlistedParkers(
        $subscriptionId: String
        $filters: [Filter]
        $order: SortOrder
        $limit: Int
        $offset: Int
        $tenantSubscriptionId: String
    ) {
      listWaitlistedParkers(
        subscriptionId: $subscriptionId,
        filters: $filters
        order: $order
        limit: $limit
        offset: $offset
        tenantSubscriptionId: $tenantSubscriptionId
      ) {
        parkers {
          id
          waitlistStartDate
          waitlistRateName
          subscriptionName
          createdAt
          lastName
          firstName
          email 
          phone
          address
          city
          readableId
          state
          zip
          accountId
          payorType
          facilityName
          facilityNumber
          facilityId
          subscriptionId
        }
        total
      }
    }
`;

export const LIST_VEHICLES_V2 = gql`
  query listVehicles(
    $filters: [Filter]
    $order: SortOrder
    $limit: Int
    $offset: Int
    $tenantSubscriptionId: String
  ) {
    listVehicles(
      filters: $filters
      order: $order
      limit: $limit
      offset: $offset
      tenantSubscriptionId: $tenantSubscriptionId
    ) {
      vehicles {
        id
        startDate
        endDate
        make
        model
        color
        decal
        license
        state
        year
        reservedSpace
        parkerId
        lastName
        firstName
        subscriptionAccountId
        facilityName
        facilityNumber
        facilityId
        subscriptionId
        subscriptionName
        terminationStatus
        suspensionStatus
      }
    }
  }
`;

export const LIST_VEHICLES_COUNT = gql`
    query listVehiclesCount(
        $filters: [Filter]
        $tenantSubscriptionId: String
    ) {
      listVehiclesCount(
          filters: $filters
          tenantSubscriptionId: $tenantSubscriptionId
      ) {
          total
    }
  }
`;

export const GET_MONTHLY_PARKER_VEHICLES_CSV = gql`
  query getMonthlyParkerVehiclesCsv(
    $filters: [Filter]
    $order: SortOrder
    $tenantSubscriptionId: String
  ) {
    getMonthlyParkerVehiclesCsv(
      filters: $filters
      order: $order
      tenantSubscriptionId: $tenantSubscriptionId
    ) {
        url
    }
  }
`;

export const GET_ORGANIZATION_PARKER_TYPES_BY_FACILITY_ID = gql`
    query getOrganizationParkerTypesByFacilityId(
        $facilityId: String!
    ) {
        getOrganizationParkerTypesByFacilityId(
            facilityId: $facilityId
        ) {
            id
            parkerTypeName
          }
    }
`;
